<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="fas fa-file-contract me-2"></i>
      {{ isEdit ? 'Modifier le contrat' : 'Ajouter un contrat' }}
    </h5>
    <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="contractForm" (ngSubmit)="onSubmit()">
      <div class="mb-3">
        <label class="form-label">Clé de répartition (%)</label>
        <input type="number" 
               class="form-control" 
               formControlName="cle_repartition"
               min="0"
               max="100"
               step="0.01">
        <div class="invalid-feedback" *ngIf="contractForm.get('cle_repartition')?.touched && contractForm.get('cle_repartition')?.errors?.['required']">
          La clé de répartition est requise
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label">Fichier du contrat</label>
        <input type="file" 
               class="form-control" 
               (change)="onFileSelected($event)"
               accept=".pdf"
               [required]="!isEdit">
        <div class="invalid-feedback" *ngIf="!isEdit && !selectedFile">
          Le fichier du contrat est requis
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Annuler</button>
        <button type="submit" 
                class="btn btn-primary" 
                [disabled]="isLoading || !contractForm.valid || (!isEdit && !selectedFile)">
          <span *ngIf="!isLoading">{{ isEdit ? 'Modifier' : 'Ajouter' }}</span>
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm"></span>
        </button>
      </div>
    </form>
  </div>
</div> 